import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';
// import * as $ from 'jquery'
@Component({
    selector: 'header-app',
    templateUrl: 'header.component.html'
})

export class HeaderComponent implements OnInit {
    menuList:any;
    documentsList: any;
    userTypeName:string;
    filtereddocList: any;
    userID: any;
    change: string;
    usersList: any;
    name: any;
    url: string;
  tempUsersList: any;
  profile: any;
    constructor(private loginService:LoginService) { 
      this.userTypeName=localStorage.getItem("userType");
    }

    ngOnInit() 
    {
        this.userID=localStorage.getItem('USERID');
  this.GetMenusByUserType(2);
  this.GetUsers();
  this.change=localStorage.getItem('PROCESS');
        
    }
    GetUsers(){
        this.loginService.GetUsers(this.userTypeName).subscribe(data=>
          {
            
            data = JSON.parse(data['_body']);
                  this.usersList=JSON.parse(JSON.stringify(data));
                  
                  for(let i=0;i<this.usersList.length;i++)
                  {
                  
                  if(this.userID==this.usersList[i].id)
                  {
                    this.name=this.usersList[i].first_name;
                    this.url=this.loginService.imageURL;
                    this.profile=this.usersList[i].Profile;
                  }
                  if(this.profile==null){
                      this.url="";
                      this.profile='../../assets/images/user.png';
                    }
                }
                this.loginService.GetUsers(this.userTypeName).subscribe(data=>
                  {
                    
                    data = JSON.parse(data['_body']);
                          this.usersList=JSON.parse(JSON.stringify(data));
                        
                  })
               
                            });
                          
                        }
    
    GetMenusByUserType(userTypeID){
this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
    {

data = JSON.parse(data['_body']);
this.menuList=JSON.parse(JSON.stringify(data));
    });
    }
}
